import { Module } from 'vuex'
import { state } from './state'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { RootState } from 'store'
import { TimesheetApproveState } from './types'

export const timeSheetsApprove: Module<TimesheetApproveState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

